import {
  ROLE_ID_MANAGER_HOMECENTER,
  ROLE_ID_MANAGER_MARKETPLACE
} from '../constants/roleIds'

export const DEFAULT_ORDER_STATUS_FALLBACK = 'verify_transaction'

function isMercadoPagoPaymentMethod(paymentMethod: string): boolean {
  return (
    paymentMethod === 'mpago' ||
    paymentMethod === 'mercado_pago' ||
    paymentMethod === 'mercadopago'
  )
}

function isHomecenterPagoPaymentMethod(paymentMethod: string): boolean {
  return paymentMethod === 'hpago'
}

/**
 * Estado por defecto al crear un pedido según el método de pago.
 * Métodos no listados → verify_transaction.
 * Manager marketplace (17) + Mercado Pago / mpago → processing.
 * Manager Homecenter (16) + hpago → processing.
 */
export function getDefaultOrderStatusByPaymentMethod(
  paymentMethod?: string,
  roleId?: number | null
): string {
  const pm = (paymentMethod || '').toString().trim().toLowerCase()

  if (roleId === ROLE_ID_MANAGER_MARKETPLACE && isMercadoPagoPaymentMethod(pm)) {
    return 'processing'
  }

  if (roleId === ROLE_ID_MANAGER_HOMECENTER && isHomecenterPagoPaymentMethod(pm)) {
    return 'processing'
  }

  switch (pm) {
    case 'cod':
      return 'processing'
    case 'bold':
      return 'pending'
    case 'plan_separe':
    case 'cmdm':
    case 'addi':
      return 'verify_transaction'
    default:
      return DEFAULT_ORDER_STATUS_FALLBACK
  }
}
